import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Debater_ENTP_personality_header from '../../images/personality_types_details/analysts_Debater_ENTP_personality_header.svg'
import analysts_Debater_ENTP_career_path from '../../images/personality_types_details/analysts_Debater_ENTP_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const entp_careers = () => {
    return (
        <Layout>
            <main class="q-td analyst debater">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/debator-entp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header analyst debater">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={analysts_Debater_ENTP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Debater</span> Personality</h1>
                        <div class="code">ENTP-A / ENTP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/debator-entp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/debator-entp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/debator-entps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Career Paths</h1>


                        <p>In the world of careers, Debaters have the benefit of being naturally engaged and interested in being productive and helpful. But rather than the sort of people-oriented helpfulness that Diplomat personality types bring to the table, Debater personalities are focused on developing solutions to interesting and diverse technical and intellectual problems. Debaters are a versatile personality type, and while it may take time for them to get to a point where they can fully utilize their skillset and qualities, they are likely to find that those qualities translate well into pretty much any career that so much as piques their interest.</p>

                        <div class="description-pullout">If there’s anything Debaters love, it’s flexing their mental muscles, and any environment that lets them devise new approaches, new ideas and new projects, that allows them to push the limits of their creativity, will benefit strongly from what Debaters bring to the table.</div>

                        <p>Not every career allows this level of unbridled brainpower, but there are those that demand nothing but: entrepreneurship, engineering, even acting and photography. So long as Debaters are honest with themselves about their strengths and weaknesses, they can thrive in most any career that is in need of a new line of thinking.</p>

                        <div class="scene">
                            <img alt="Debater (ENTP) careers" src={analysts_Debater_ENTP_career_path} />
                        </div>

                        <h2>The Value of an Idea Lies in the Using of It</h2>

                        <p>All this intellectual power can be intimidating, but unlike their Introverted (I) cousins, people with the Debater personality type have the added benefit of being excellent communicators, in the written word but especially in face-to-face conversation. Though they dislike the constraints of managing others (and of being managed), this social adaptability allows Debaters to be natural leaders, showing the way forward and inspiring others with sound logic and intellectual prowess. While others may object to these plans with emotional considerations or general resistance to change, things Debaters place little value in, these competing comments are usually outmaneuvered by Debater personalities’ deft arguments and subtly shifting goals.</p>

                        <p>The best careers reward intellectual competency and curiosity, allowing Debaters to utilize their never-ending flow of ideas productively by affording a degree of spontaneity in how they engage their intellectual pursuits. People with the Debater personality type value knowledge, rational thought and insight very highly, and they make brilliant lawyers, psychologists, systems analysts and scientists. It’s even possible for Debaters to thrive as sales representatives, as they rationalize purchase decisions that may otherwise seem discretionary – so long as their managers know to give them the space they need to work their magic.</p>

                        <h2>Being Busy Doesn’t Always Mean Real Work</h2>

                        <p>Really it all comes down to a sense of personal freedom, for Debaters to know that they are allowed to apply themselves fully to understanding and solving the problems that interest them, without getting bogged down by social politics and trying to figure out what makes other people “tick”. Routine, structure and formal rules all feel like unnecessary hindrances to Debaters, and they may find that their best careers yet allow them to engage their intellectual pursuits on their own terms, as freelance consultants or software engineers.</p>

                        <p>The key for Debaters is to have the patience to get to a position that allows for these freedoms, to be in an environment long enough that not just their colleagues, but their managers and, in time, their subordinates, recognize what it is that they bring to the table. Debaters have exceptional qualities – it’s quantifying their achievements and skills that presents the biggest challenge. But once they’ve got their foot in the door, once they’ve got a willing ear higher in the hierarchy, the sky’s the limit.</p>

                        <div class="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/debator-entp-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/debator-entps-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default entp_careers
